/** ---- ADMIN ----- */
const admin = [
  {
    component: () => import('@/app/admin/pages/Admin.vue'),
    name: 'Admin',
    path: '/admin/',
    meta: {
      rights:{
        levels : [6],
        name : 'Admin'
      }
    }
  },
  {
    component: () => import('@/app/admin/pages/Admin_Company_Edit.vue'),
    name: 'Admin_Company_Edit',
    path: '/admin/entreprise/:cmp_id(\\d+)/',
    meta: {
      rights:{
        levels : [6],
        name : 'Admin'
      }
    }
  },
  {
    component: () => import('@/app/admin/pages/Admin_Company_Create.vue'),
    name: 'Admin_Company_Create',
    path: '/admin/entreprise/ajouter/',
    meta: {
      rights:{
        levels : [6],
        name : 'Admin'
      }
    }
  },
  {
    component: () => import('@/app/admin/pages/Admin_User_Edit.vue'),
    name: 'Admin_User_Edit',
    path: '/admin/entreprise/:cmp_id(\\d+)/utilisateur/:con_id(\\d+)/',
    meta: {
      rights:{
        levels : [6],
        name : 'Admin'
      }
    }
  },
  {
    component: () => import('@/app/admin/pages/Admin_User_Create.vue'),
    name: 'Admin_User_Create',
    path: '/admin/entreprise/:cmp_id(\\d+)/utilisateur/ajouter/',
    alias: '/admin/utilisateur/ajouter/',
    meta: {
      rights:{
        levels : [6],
        name : 'Admin'
      }
    }
  },
  {
    component: () => import('@/app/admin/pages/Admin_User_Create.vue'),
    name: 'Admin_User_Create',
    path: '/admin/entreprise/:cmp_id(\\d+)/utilisateur/ajouter/',
    alias: '/admin/utilisateur/ajouter/',
    meta: {
      rights:{
        levels : [6],
        name : 'Admin'
      }
    }
  },
  {
    component: () => import('@/app/admin/pages/Admin_Sys_Log.vue'),
    name: 'Admin_Sys_Log',
    path: '/admin/syslog',
    meta: {
      rights:{
        levels : [6],
        name : 'Admin'
      }
    }
  },
];
/** ---- ADMIN END ----- */
const router = [
  ...admin,
];

export default router;
